<script lang="ts">
    import type { Map } from "maplibre-gl";
    import { onMount, getContext } from "svelte";
    import { key } from "../../map/map";

    const { getMap } = getContext(key);
    const map: Map = getMap().map;

    onMount(async () => {
        map.on("load", () => {
            map.addSource("aiv", {
                type: "raster",
                tiles: [
                    "https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=GvoVAJgu46I5rZapJuAy",
                ],
                tileSize: 256,
                attribution: "AIV",
            });

            map.addLayer(
                {
                    id: "background-imagery",
                    type: "raster",
                    source: "aiv",
                    minzoom: 0,
                    maxzoom: 20,
                    layout: {
                        visibility: "none",
                    },
                },
                "background"
            );
        });
    });
</script>
